import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators';
import { BILL_CATEGORY_DETAILS_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getCategoryDetailsRequest,
  getCategoryDetailsSuccess,
  getCategoryDetailsFailure,
} from '../actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';
import { IBillCategoryDetailsResponse } from '@dch/billing-business-logic';

@Injectable()
export class CategoryDetailsEffects {
  getCategoryDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCategoryDetailsRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(
        ([
          { documentReference, category, billingAccountNumber },
          { customerId },
        ]) =>
          EntityManager.getEntity<IBillCategoryDetailsResponse>(
            BILL_CATEGORY_DETAILS_ENTITY,
            {
              cdbId: customerId,
              paNumber: billingAccountNumber,
              reference: documentReference,
              category,
            }
          ).pipe(
            map((entity) =>
              entity.value
                ? getCategoryDetailsSuccess({
                    documentReference,
                    category,
                    payload: entity.value,
                  })
                : getCategoryDetailsFailure({
                    documentReference,
                    category,
                  })
            ),
            catchError((error) =>
              of(
                getCategoryDetailsFailure({
                  documentReference,
                  category,
                })
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
